import { styled } from "@mui/material/styles";

export const CreateAddressContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const EmailPreferenceContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._300,
    alignSelf: "stretch",
}));

export const EmailPreferenceTitle = styled("div")(({ theme }) => ({
    color: theme.colors["neutral.400"],
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));

export const EmailPreferenceSubTitle = styled("div")(({ theme }) => ({
    color: theme.colors["neutral.500"],
    fontSize: theme.fontSizes.xs,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base
}));
